// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"8":"lg-plugin-0","238":"lg-plugin-1","359":"lg-plugin-5","400":"lg-plugin-4","515":"lg-plugin-6","568":"lg-plugin-10","642":"lg-plugin-8","649":"lg-plugin-3","719":"lg-plugin-11","725":"lg-plugin-9","846":"lg-plugin-2","893":"lg-plugin-7"}[chunkId] || chunkId) + ".js";
};